import { Record } from 'immutable';

const OnlineHomeworkResultRecord = Record({
  averageScorePercentage: undefined,
  completedAssignments: undefined,
  totalAssignments: undefined,
});

class OnlineHomeworkResult extends OnlineHomeworkResultRecord {}

export default OnlineHomeworkResult;




// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/OnlineHomeworkResult/model.js